import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Popover as PopoverLib } from 'react-tiny-popover';
import { Icon } from '../Icon';
import infoImageSrc from '../../assets/images/popover-info.png';
import styles from './Popover.css';

const cx = classnames.bind(styles);

function Popover({
    className,
    children,
    description,
    title
}) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const classes = cx({
        root: true,
        [className]: className
    });

    const closePopover = () => setIsPopoverOpen(false);

    return (
        <PopoverLib
            isOpen={isPopoverOpen}
            padding={8}
            positions={['bottom', 'top', 'right', 'left']}
            containerClassName={styles.container}
            boundaryElement={document.getElementById('current-screen')}
            reposition
            onClickOutside={closePopover}
            content={() => (
                <div className={classes}>
                    <div className={styles.head}>
                        <img
                            src={infoImageSrc}
                            alt='info'
                        />
                        {title ? <span>{title}</span> : children}
                        <Icon name='closeSecondary' onClick={closePopover} />
                    </div>
                    <p className={styles.description}>{description}</p>
                </div>
            )}
            >
            <div className={styles.target} onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                {children}
            </div>
        </PopoverLib>
    );
};

Popover.propTypes = {
    children: PropTypes.any.isRequired,
    description: PropTypes.any,
    title: PropTypes.string,
    className: PropTypes.string
};

Popover.defaultProps = {
    className: '',
    description: ''
};

export {
    Popover
};
